import type { AppLanguage } from "../i18n/config";
import { buildLocalizedPath } from "../i18n/routing";
import { I18N_ROUTING } from "./site";

export const PAGES = {
  main: "/",
  // The login page is NOT shipped with the template. The route guards
  // (ProtectedRoute / PublicRoute) redirect here, so the project must
  // implement a login page and register this route in its routers.
  login: "/login",
  /**
   * Public-share URL for a single demo session. The `:workflowId` segment
   * is the UUID returned by `POST /api/demo/workflows`; visiting this URL
   * hydrates the scene store from the backend timeline so the receiver
   * sees the exact same step state as the sender.
   */
  demoSession: "/demos/land/:workflowId",
  /** Land (foncier) demo landing — moved off "/" now that "/" is the hub. */
  land: "/demos/land",
  /** Certif demo — document anchoring sub-app. */
  certif: "/demos/certif",
  /** Cbam demo — carbon / MACF emission-attestation sub-app. */
  cbam: "/demos/cbam",
} as const;

/**
 * Builder for the demo-session URL with a concrete workflow id.
 * Mirrors `getPagePath("demoSession", language)` but performs the
 * `:workflowId` substitution so callers do not template the path
 * themselves.
 */
export function buildDemoSessionPath(
  workflowId: string,
  language?: AppLanguage,
): string {
  const base =
    I18N_ROUTING && language
      ? `/${language}/demos/land/${workflowId}`
      : `/demos/land/${workflowId}`;
  return base;
}

export type PageKey = keyof typeof PAGES;

export function getPagePath(page: PageKey, language?: AppLanguage): string {
  const pagePath = PAGES[page];

  if (I18N_ROUTING && language) {
    return buildLocalizedPath(language, pagePath);
  }

  return pagePath;
}
